export default __webpack_public_path__ + "static/media/ibo.2238409a.png";